import { useMutation, useQueryClient } from '@tanstack/react-query';

import { invalidateAdminApprovals } from '~/lib/approvals';
import { PlatformRepository } from '~/repositories/PlatformRepository';
import { useSessionStore } from '~/stores/Session';

export const useSaveUserChangeApproval = (onChange: (value: boolean) => void) => {
  const { currentPlatform } = useSessionStore();
  const queryClient = useQueryClient();
  const savedValue = currentPlatform?.requireUserChangeApproval ?? false;

  return useMutation({
    mutationFn: ({ platformId, value }: { platformId: string; value?: boolean }) => {
      if (value === undefined || value === savedValue) {
        return Promise.resolve({ pendingApproval: false });
      }
      return PlatformRepository.updateUserChangeApproval(platformId, value);
    },
    onSuccess: async ({ pendingApproval }, { value }) => {
      if (value === undefined || value === savedValue) return;
      if (pendingApproval) onChange(savedValue);
      await invalidateAdminApprovals(queryClient);
    },
  });
};
